const DashboardMarketingCell = () => {
  return (
    <div
      className='card card card-xl-stretchcard_borderC bg-navy_blue'
      style={{ width: '100%', height: '100%' }}
    >
      {/* begin::Body */}
      <div className='card-body d-flex flex-wrap align-items-center gap-8 px-10 py-10'>
        <div className='symbol symbol-100px symbol-circle flex-shrink-0'>
          <span className='symbol-label bg-white'>
            <i className='fa-duotone fa-handshake fs-3x text-primary' />
          </span>
        </div>
        <div className='d-flex flex-column flex-grow-1 gap-3' style={{ minWidth: 280 }}>
          <span className='text-white fw-bold fs-2tx lh-1'>Få hjelp med rekrutteringen</span>
          <span className='text-white opacity-75 fs-2'>
            Jostein hjelper dere med å sette opp lagene og lagkodene, og med arket til
            lagledermøtet.
          </span>
        </div>
        <div className='d-flex flex-wrap gap-4'>
          <a href='mailto:jostein@stotte.no' className='btn btn-light btn-lg fw-bold fs-3'>
            <i className='fa-duotone fa-envelope fs-2 text-primary me-3' />
            jostein@stotte.no
          </a>
          <a href='tel:+4791865859' className='btn btn-light btn-lg fw-bold fs-3'>
            <i className='fa-duotone fa-phone fs-2 text-primary me-3' />
            918 65 859
          </a>
        </div>
      </div>
    </div>
  )
}

export { DashboardMarketingCell }
